export const TAB_ALL = 'all';
export const TAB_SEARCH = 'search';
export const TAB_NEAREST = 'nearest';

export const SECTION_SALES_REPREZENTATIVES = 'sales-representatives';
export const SECTION_PROJECT_TEAM = 'project-managers';




// WEBPACK FOOTER //
// ./src/components/contact/constants.js